<template>
  <div v-if="schedules && schedules.length > 0">
    <div>
      <div
        v-for="schedule in schedules"
        :key="schedule.id"
        class="border-bottom"
      >
        <CaseScheduleView
          :schedule-id="schedule.id"
          :case-id="current.id"
          :report="report"
        ></CaseScheduleView>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import CaseScheduleView from "@/components/Panel/Doctor/CaseScheduleView";
export default {
  components: {
    CaseScheduleView
  },
  props: {
    value: {
      type: String,
      required: true
    },
    report: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      authLocale: "auth/locale",
      caseById: "pcase/byId",
      schedules: "schedule/schedules"
    }),
    current() {
      return this.caseById(this.value);
    }
  },
  watch: {
    value() {
      this.fetchSchedules();
    }
  },
  mounted() {
    this.fetchSchedules();
  },
  methods: {
    ...mapMutations({
      setError: "alert/setError",
      setSchedule: "schedule/set",
      resetSchedule: "schedule/reset"
    }),
    async fetchSchedules() {
      this.resetSchedule();
      this.loading = true;
      try {
        const response = await this.axios.get(
          `/api/patient-cases/${this.value}/schedules`
        );
        const schedules = response.data.data;
        for (const schedule of schedules) {
          this.setSchedule({
            id: schedule.id,
            city_id: schedule.city_id,
            address: schedule.address,
            patient_id: schedule.patient_id,
            patient: schedule.patient,
            clinic_service_id: schedule.clinic_service_id,
            clinic_service: schedule.clinic_service,
            clinic_id: schedule.clinic_id,
            service_id: schedule.service_id,
            assignee_id: schedule.assignee_id,
            assignee: schedule.assignee,
            communication_days: schedule.communication_days,
            start_time: schedule.start_time,
            status: schedule.status,
            price: schedule.price,
            comment: schedule.comment,
            interview_id: schedule.interview_id,
            interview_status: schedule.interview_status,
            patient_case_id: schedule.patient_case_id,
            created_at: schedule.created_at,
            created_by: schedule.created_by
          });
        }
        this.loading = false;
      } catch (err) {
        this.setError(err);
        this.loading = false;
      }
    }
  }
};
</script>
